import { makeStyles } from 'lib/components';

export default makeStyles((theme) => ({
  root: ({ colorTheme, colorIntensity, fontWeight }) => ({
    color: (colorTheme && colorIntensity) ? theme.evPalette[colorTheme][colorIntensity] : theme.evPalette.charcoal[900],
    fontWeight: fontWeight || 'normal',
    fontStyle: 'normal',
    fontFamily: 'Noto Sans',
  }),
  'type-h1': {
    fontSize: '32px',
    lineHeight: '48px',
  },
  'type-h2': {
    fontSize: '24px',
    lineHeight: '36px',
  },
  'type-h3': {
    fontSize: '18px',
    lineHeight: '27px',
  },
  'type-h4': {
    fontSize: '16px',
    lineHeight: '24px',
  },
  'type-h5': {
    fontSize: '14px',
    lineHeight: '18px',
  },
  'type-body': {
    fontSize: '16px',
    lineHeight: '24px',
  },
  'type-subtitle': {
    fontSize: '14px',
    lineHeight: '21px',
  },
  'type-label': {
    fontSize: '12px',
    lineHeight: '18px',
  },
  'type-caption': {
    fontSize: '10px',
    lineHeight: '15px',
  },
}));
